import 'phaser'
import App from '../main';
import { Game, Direction, GameState } from '../app/game';
import { RoadPiece, RoadType } from './RoadPiece';

export default class ControlPoint extends Phaser.GameObjects.Sprite {

    private game;

    public rotationDirection: rotationDirections;

    public collider: Phaser.Physics.Matter.Sprite;

    public targetDirection: Direction;

    public road: RoadPiece;
    public inRange: boolean = false;
    public canLatch: boolean = false;

    public cpNumber: number;
    public text: Phaser.GameObjects.Text;
    // public textCollider: Phaser.Physics.Matter.Sprite;

    tweenText: boolean = false;

    constructor(scene: Phaser.Scene, road?: RoadPiece) {
        super(scene, 0, 0, 'spritesAtlaas', "controlPoint.png");
        this.game = scene;
        this.setScale(0.5)
        var colliders = App.colliderData;
        switch (road.roadType) {

            case RoadType.turn:
                this.collider = scene.matter.add.sprite(0, 0, 'spritesAtlaas', 'empty.png');
                this.collider.setRectangle(250, 250, { isSensor: true }); break;
            case RoadType.uturn:
                this.collider = scene.matter.add.sprite(0, 0, 'spritesAtlaas', 'empty.png');
                this.collider.setRectangle(500, 200, { isSensor: true }); break;
            case RoadType.loop:
                this.collider = scene.matter.add.sprite(0, 0, 'spritesAtlaas', 'empty.png', { shape: colliders.loop_cp_collider, isSensor: true }); break;
        }
        // this.collider = scene.matter.add.sprite(0, 0, 'spritesAtlaas', 'empty.png', { shape: colliderType, isSensor: true })

        this.road = road;
        this.depth = 5;
        this.game.add.existing(this);
        scene.matter.world.on('collisionstart', this.onCollisionStart.bind(this));
        scene.matter.world.on('collisionend', this.onCollisionExit.bind(this));

        // this.textCollider = this.game.matter.add.sprite(0, 0, 'spritesAtlaas', 'empty.png')
        //  this.textCollider.setCircle(60, { isSensor: true });
        this.text = this.game.add.text(0, 0, " ")
        this.text.setStyle({ fontFamily: 'bungee', fontSize: '60px', color: '#c9bfd5', stroke: '#281a37', strokeThickness: 15 });
        this.text.depth = 3;
        this.text.setOrigin(0.5, 0.5)
        this.setVisible(false)

    }

    InstantiateControlPoint(x: number, y: number, rotation?: rotationDirections, direction?: Direction, spriteX?: number, spriteY?: number, road?: RoadPiece, cpNumber?: number) {

        this.canLatch = false;
        this.collider.setPosition(x, y);
        this.CorrectColliderOffset();
        this.collider.angle = road.angle;
        this.setPosition(spriteX, spriteY)
        this.rotationDirection = rotation;
        this.targetDirection = direction;
        this.cpNumber = cpNumber;
        this.alpha = 0.5;
        this.setVisible(true)
        this.createText();
        this.tweenText = true;
    }

    createText() {
        //text position
        let x, y;
        switch (this.road.roadType) {
            case RoadType.turn:
                x = this.x + (-this.road.offSetDirectionX * 95)
                y = this.y + (-this.road.offSetDirectionY * 95)
                break;
            case RoadType.uturn:
                switch (Game.currentGameDirection) {
                    case Direction.left:
                    case Direction.right:
                        x = this.x
                        y = this.y + (-this.road.offSetDirectionY * 150)
                        break;

                    case Direction.up:
                    case Direction.down:
                        x = this.x + (-this.road.offSetDirectionX * 150)
                        y = this.y

                        break;
                }

                break;
            case RoadType.loop:
                //do later
                x = this.x + (-this.road.offSetDirectionX * 125)
                y = this.y + (-this.road.offSetDirectionY * 125)
                break;
        }

        this.EnableCP(true)
        // this.textCollider.setPosition(x, y);
        this.text.text = this.cpNumber.toString()
        this.text.setPosition(x, y)
        this.text.alpha = 0.5;
    }

    EnableCP(bool: boolean) {
        this.text.setActive(bool)
        this.text.setVisible(bool)
        this.setVisible(bool)
        this.setActive(bool)
        let collisionLayer

        if (bool) {
            collisionLayer = Game.enableCollisionLayer
        }
        else {
            collisionLayer = Game.disableCollisionLayer
        }

        this.collider.setCollisionCategory(collisionLayer)
        //  this.textCollider.setCollisionCategory(collisionLayer)
    }
    onCollisionExit(event, bodyA, bodyB) {
        if ((bodyA.parent == this.collider.body && bodyB.parent == Game.car.carSprite.body) || (bodyA.parent == Game.car.carSprite.body && bodyB.parent == this.collider.body)) {
            Game.cpOutOfRange(this);
        }
    }

    onCollisionStart(event, bodyA, bodyB) {
        if ((bodyA.parent == this.collider.body && bodyB.parent == Game.car.carSprite.body) || (bodyA.parent == Game.car.carSprite.body && bodyB.parent == this.collider.body)) {
            Game.setCurrentControlPoint()
            Game.controlPointOutOfRange = false;
            Game.car.setDirection(this.targetDirection)
            if (this.road.roadType == RoadType.loop) {

                this.game.time.addEvent({
                    delay: 1000,
                    callback:  ()=> {
                        this.road.nextRoad.collider.setCollisionCategory(Game.enableCollisionLayer)
                        this.road.nextRoad.depth = 1
                    },
                    callbackScope: this
                })  

            }

            this.DelayAndTween()
        }
        // if ((bodyA == this.textCollider.body && bodyB.parent == Game.car.carSprite.body) || (bodyA.parent == Game.car.carSprite.body && bodyB == this.textCollider.body)) {
        //     this.TweenText();
        //     this.textCollider.setCollisionCategory(Game.disableCollisionLayer)
        //     this.game.IncreaseScore();

        // }

    }
    DelayAndTween() {
        let delay: number = 150;
        switch (this.road.roadType) {
            case RoadType.uturn: delay = 200; break;
            case RoadType.loop: delay = 600; break;

        }
        this.game.time.addEvent({
            delay: delay,
            callback:  ()=> {
                if (Game.currentGameState == GameState.Game) {
                    this.TweenText();
                    this.game.IncreaseScore();
                }
            },
            callbackScope: this
        })  

    }

    TweenText() {
        if (this.tweenText) {
            this.tweenText = false;
            this.game.tweens.add({
                targets: this.text,
                scale: 1.5,
                duration: 200,
                onComplete: () => {
                    this.game.tweens.add({
                        targets: this.text,
                        scale: 1,
                        duration: 350,
                        ease: Phaser.Math.Easing.Back.Out,
                        setParams: [3]
                    });
                }
            });
            this.game.tweens.add({
                targets: this.text,
                alpha: 1,
                duration: 300
            });
        }
    }

    CorrectColliderOffset() {
        let offsetX = 0;
        let offsetY = 0;

        switch (this.road.roadType) {

            case RoadType.uturn: offsetY = - 15; break;
            case RoadType.loop:
                offsetX = this.road.width / 4 - this.collider.centerOfMass.x;
                offsetY = this.road.height / 4 - this.collider.centerOfMass.y;
                break;
        }

        //up or down switch x y 
        if (Game.currentGameDirection == 2 || Game.currentGameDirection == 3) {
            let temp = offsetX;
            offsetX = offsetY;
            offsetY = temp
        }

        this.collider.setPosition(this.collider.x + (this.road.offSetDirectionX * offsetX),
            this.collider.y + (this.road.offSetDirectionY * offsetY))
    }

    Scale(up: boolean) {
        let scaleSize = 0.65;
        if (!up) {
            scaleSize = 0.5;
        }
        this.scale = scaleSize;
    }

    AlphaTween(enable: boolean) {
        let alphaValue = 1;
        if (!enable) {
            alphaValue = 0.5;
        }

        this.game.tweens.add({
            targets: this,
            alpha: alphaValue,
            duration: 120
        });
    }

    Reset() {
        this.text.alpha = 0.5;
        //this.textCollider.setCollisionCategory(Game.enableCollisionLayer)
        if (this.road.roadType == RoadType.loop) {
            this.road.nextRoad.collider.setCollisionCategory(Game.disableCollisionLayer)
            this.road.nextRoad.depth = 6
        }
    }
}


export enum rotationDirections { clockwise = 1, anticlockwise = -1 }

